import { Layout } from '@/modules/shared/layouts/layout'
import { usePromotionSearch } from '../hooks/use-promotion-search.hook'
import { PromotionSearchInterface } from '../interfaces/promotion-search.interface'
import { useAuthStore } from '@/modules/shared/stores/auth.store'
import { Button } from '@/modules/shared/components/ui/button'
import { AlertCircle } from 'lucide-react'

export function PromotionSearchContainer() {
	const promotionSearch = usePromotionSearch()
	const { versionUrl } = useAuthStore()

	const isFeatureAvailable = versionUrl === 'erp/v3'

	if (isFeatureAvailable) {
		return (
			<Layout pageTitle="Recurso Indisponível" handleGoBack={promotionSearch.handleBackPage}>
				<div className="flex flex-col items-center justify-center min-h-[60vh] p-4">
					<div className="border rounded-md p-6 max-w-xs w-full text-center">
						<AlertCircle className="mx-auto h-8 w-8 text-gray-500 mb-3" />
						<h2 className="text-base font-medium text-gray-800 mb-4">Recurso Não Disponível</h2>
						<Button
							onClick={promotionSearch.handleBackPage}
							variant="outline"
							size="sm"
						>
							Voltar
						</Button>
					</div>
				</div>
			</Layout>
		)
	}

	return (
		<Layout pageTitle="Visitas do Promotor" handleGoBack={promotionSearch.handleBackPage}>
			<PromotionSearchInterface {...promotionSearch} />
		</Layout>
	)
}